import { Component, OnInit } from '@angular/core';
import { ApplicationService } from 'app/services/application.service';
import { StatusService } from 'app/services/status.service';
import { AuthWebService } from 'app/services/authweb.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CompliancereturnsService } from 'app/services/compliancereturns.service';
import { CalendarService } from '../../services/calendar.service';
import { ToastrService } from "ngx-toastr";
import { CarrierService } from 'app/services/carrier.service';
import { accounting } from 'accounting';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'app-compliance-return-list',
  templateUrl: './compliance-return-list.component.html',
  styleUrls: ['./compliance-return-list.component.css']
})
export class ComplianceReturnListComponent implements OnInit {

  pageSize: number = 10;
  
  count: number = 0;
  isEmpty: boolean = false;
  carrierpermitlist: any;
  carrierid: number;
  calendarid: number =0;
  isView: boolean = false;
  applicationId: number = 0;
  calendarList: any = [];
  lastSixMonths: any = [];z
  page: number = 0;
  isLoading: boolean = false;
  Carrier : any;
  
  constructor(public utility: UtilityServiceService,private router: Router,private toastService:ToastNotificationService, public complianceservice: CompliancereturnsService, public _calandarService: CalendarService, private activeRoute: ActivatedRoute, private toastr: ToastrService,private carrierService : CarrierService) { }

  ngOnInit() {

    // this._calandarService.getFirstMonths().subscribe(data => {
    //   this.calendarList = data;
    //   const dt = new Date();
    //   const thisMothCal = this.calendarList.find(x => dt.getMonth() + 1 == new Date(x.calendar_date).getMonth() + 1 && dt.getFullYear() == new Date(x.calendar_date).getFullYear());
    //   this.lastSixMonths = this.calendarList.slice(Math.max(this.calendarList.length - 6, 0));

   
  
      
    // });
    this.activeRoute.params.subscribe((params: Params) => {

      this.carrierid = params['carrierid'];
      this.calendarid = params['calendarid'];
      this.isView = params['action'];
      this.applicationId = params['appId'];
      this.getCarrier(this.carrierid,);
      this.getCarrierList(this.carrierid, this.calendarid);
    });
 
  }


  onChange(): void {

  }
  onSearch(): void {

  }
  onReset(): void {

  }

  viewComplianceApplication(item)
  {
    this.router.navigate(['/carrier/compliance/application'] ,{ queryParams: { id:item.carrier_id,appID:item.application_id, compID:item.id,typeId:item.permit_type_id, isView:this.isView} });
  }

  showDetails(item){

    if(item.compliance_status.indexOf('Submitted') > 0)
    {
      return this.toastService.error('Your Annual Compliance Application is being processed, you will be notified once it is finalised.','Error');
    }
    
    var due = new Date(item.compliant_duedate);
    var today = new Date();
    var dateDif = this.dayDiff(today, due);
    
    if(due > today && dateDif > 30)
    {
      return this.toastService.error('Permit is still Compliant','Error');
    }
    else{
    this.router.navigate(['/carrier/compliance/application'] ,{ queryParams: { id:item.carrier_id,appID:item.application_id, compID:item.id,typeId:item.permit_type_id} });
    }
  } 

  dayDiff(d1:Date, d2:Date)
  {
    var diff = Math.abs(d1.getTime() - d2.getTime());
    var diffDays = Math.ceil(diff / (1000 * 3600 * 24)); 
    return diffDays;
  }

  getCarrier(carrierid)
  {
      this.carrierService.getById(carrierid).subscribe(carrier=>{
        this.Carrier = carrier;
      });
  }

  formatCurrency(value) {
    return accounting.formatMoney(value, 'R', 2, ' ', '.');
  }

  getCarrierList(carrierid , calendarid){
    this.isLoading = true;
    this.complianceservice.getcarrierpermitlist(carrierid ,calendarid).subscribe((data: any) => {
      if (data != undefined || data != null) {
        console.log("int data" + JSON.stringify(data));

        this.carrierpermitlist = this.isView ? data.filter(x=>x.application_id==this.applicationId) :data;
        this.isLoading = false;

       
      }
    })
  }

  goBack()
  {
    if(this.isView){
      this.router.navigate(['carrier/permit/application/' + this.carrierid]);
    }
    else{
    this.router.navigate(['carrier/accounts/']);
    }
  }
}
